import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LeadPrioritization, LeadResponse } from "../interfaces/lead-prioritization.interface";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class LeadPrioritizationService {
  constructor(private http: HttpClientService) {}

  public getByPerson(person_id: string | number): Observable<LeadPrioritization> {
    return this.http
      .get<LeadPrioritization>(`/api/persons/${person_id}/lead_prioritization`)
      .pipe(tap((_) => console.log("LeadPrioritizationService.getByPerson: Ok.")));
  }

  public update(
    lead_prioritization_id: string | number,
    lead_response: LeadResponse | null
  ): Observable<LeadPrioritization> {
    return this.http
      .put(`/api/lead_prioritizations/${lead_prioritization_id}`, {
        lead_prioritization: { lead_response },
      })
      .pipe(tap((_) => console.log("LeadPrioritizationService.update: Ok.")));
  }
}
